<template>
  <div>
    <button
      v-if="app.root_link.type == CONSTANTS.ROOT_LINK_TYPES.AZURE_ACCESS_LINK"
      :class="(currentRoute.includes('view-app')?'btn flat-blue-btn':'root-link')"
      @click="showAccessRequestModal(app.root_link)"
      :title="app.root_link.help | trim"
    >{{app.root_link ? app.root_link.title : 'Website'}}</button>
    <a v-else-if="app.root_link.type == CONSTANTS.ROOT_LINK_TYPES.LINK"
      :class="(currentRoute.includes('view-app')?'btn flat-blue-btn':'root-link')"
      :target="app.root_link.reference.action ? app.root_link.reference.action : '_blank'"
      :href="app.root_link.reference.link"
      @click="openRootLink(app, currentRoute)"
      :title="app.root_link ? app.root_link.title : 'Website'"
    >
      {{app.root_link ? app.root_link.title : 'Website'}}
    </a>
    <button
      v-else-if="!app.downloadData.isDownloading && !app.downloadData.downloadReady"
      :class="(currentRoute.includes('view-app')?'btn flat-blue-btn':'root-link')"
      @click="openRootLink(app, currentRoute)"
      :title="app.root_link.help | trim"
    >{{app.root_link ? app.root_link.title : 'Website'}}</button>
    <div class="progress-container" v-if="app.downloadData.isDownloading ">
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          :style="'width:'+app.downloadData.progress+'%'"
          :aria-valuenow="app.downloadData.progress"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <p>
        {{app.downloadData.stateText}}
        <button
          class="cancel-dl-btn"
          title="Cancel download"
          @click="cancelDownload(app)"
        >
          <font-awesome-icon icon="times"/>
        </button>
      </p>
    </div>
    <div class="app-download-container" v-if="app.downloadData.downloadReady">
      <button
        class="btn flat-green-btn"
        @click="openDownloadLink(app, currentRoute)"
        title="Download file"
      >{{app.downloadData.stateText}}</button>
    </div>
    <download-modal
          :model="app"
          :viewId="CONSTANTS.VIEW_IDS.DETAIL_VIEW_ID"
          v-if="app.root_link.type === CONSTANTS.ROOT_LINK_TYPES.DIRECT_DOWNLOAD"
          v-show="displayModal"
          @close="closeModal"
        />
    <access-request-modal
        v-if="displayAccessRequestModal"
        :model="app"
        :linkData="app.root_link"
        @close="closeAccessRequestModal"
      />
  </div>
</template>

<script>
import util from "@/util";
import AppHandlerMixin from "@/mixins/AppHandlerMixin";
import * as CONSTANTS from "../constants.js";

export default {
  name: "RootLink",
  props: {
    app: Object
  },
  mixins: [AppHandlerMixin],
  computed: {
  },
  data: function() {
    return {
      CONSTANTS,
      currentRoute: this.$router.currentRoute.path
    };
  },
  mounted() {
  },
  methods: {}
};
</script>

<style scoped>
.root-link {
  font-size: 13px;
  font-weight: bold;
  color: var(--secondary-color);
  border: none;
  background: #fff;
  text-decoration: none;
  float: right;
  white-space: nowrap;
  padding-top: 3px;
}
.root-link:hover {
  font-weight: bolder;
  color: #6a6aff;

}
.action-container .btn {
  width: 100%;
  height: 30px;
  overflow: hidden;
}

.cancel-dl-btn {
  background: transparent;
  border: none;
  color: red;
  font-size: 14px;
  float: right;
}
</style>
